import { Component, Input } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { globalValidators } from '@shared/constants/global-validators.const';
import { ValidatorFormEntityEnum } from '@shared/enums/validator-form-entity.enum';

@Component({
    selector: 'app-validation-error',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './validation-error.component.html',
    styleUrl: './validation-error.component.scss',
})
export class ValidationErrorComponent {
    @Input({ required: true }) fieldId!: string;
    @Input() customFormControl!: FormControl;
    @Input({ required: true }) formEntity!: ValidatorFormEntityEnum;
    @Input() displayCustomContent: boolean = false;
    @Input() displayErrorOnInputChangeRealTime: boolean = false;

    errorMessage: string = '';
    errorKey: string = '';

    constructor(private translateService: TranslateService) {}

    ngOnInit(): void {
        if (this.customFormControl && this.customFormControl.errors) {
            this.computeErrorMessageAndParams(this.customFormControl.errors);
        }
        this.customFormControl?.statusChanges.subscribe(() => {
            if (this.customFormControl.errors) {
                this.computeErrorMessageAndParams(this.customFormControl.errors);
            }
        });
    }

    private computeErrorMessageAndParams(errors: ValidationErrors): void {
        this.errorKey = Object.keys(errors)[0];
        const errorData = globalValidators(this.customFormControl.value)[this.formEntity][this.errorKey];
        if (errorData) {
            this.errorMessage = errorData.keys
                .map(({ key, params }) => {
                    const translatedParams = params ? this.translateParams(params) : {};
                    return this.translateService.instant(key, translatedParams);
                })
                .join(' ');
        }
    }

    private translateParams(obj: Record<string, string | number>): Record<string, string | number> {
        const translatedObj: Record<string, string | number> = {};

        Object.keys(obj).forEach((key: string) => {
            const value = obj[key];
            if (typeof value === 'string') {
                translatedObj[key] = this.translateService.instant(value);
            } else {
                translatedObj[key] = value;
            }
        });

        return translatedObj;
    }
}
